import { type FirebaseApp, initializeApp } from "firebase/app";
import { type Auth, getAuth } from "firebase/auth";

interface FirebaseEnv {
  VITE_FIREBASE_API_KEY?: string;
  VITE_FIREBASE_AUTH_DOMAIN?: string;
  VITE_FIREBASE_PROJECT_ID?: string;
  VITE_FIREBASE_APP_ID?: string;
}

/** True only when the minimum Firebase Auth config is present. */
export function isFirebaseConfigured(env: FirebaseEnv): boolean {
  return Boolean(
    env.VITE_FIREBASE_API_KEY && env.VITE_FIREBASE_AUTH_DOMAIN && env.VITE_FIREBASE_PROJECT_ID,
  );
}

const env = import.meta.env as unknown as FirebaseEnv;

export const firebaseEnabled = isFirebaseConfigured(env);

let app: FirebaseApp | null = null;
let authInstance: Auth | null = null;

if (firebaseEnabled) {
  app = initializeApp({
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    appId: env.VITE_FIREBASE_APP_ID,
  });
  authInstance = getAuth(app);
}

/** The Auth instance, or null when Firebase is not configured. */
export const auth = authInstance;

/** Returns the Auth instance or throws a friendly error when unconfigured. */
export function requireAuth(): Auth {
  if (!authInstance) {
    throw new Error(
      "Firebase가 설정되지 않았습니다. .env.local에 VITE_FIREBASE_* 값을 채워주세요.",
    );
  }
  return authInstance;
}
